export class UpdatePropertyPhaseRequest{
    public propertyId!:number;
    public propertyPhaseId!:number;
    public userId!:string;
    public businessId!:string;
}